import React from 'react';
import { object, string, ref } from 'yup';
import omit from 'lodash/omit';
import {
  Formik,
  Form,
} from 'formik';
import { faClipboardCheck } from '@fortawesome/free-solid-svg-icons/faClipboardCheck';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormHttpAlert from '~/commons/components/FormHttpAlert.jsx';
import FormHttpSaveBtn from '~/commons/components/FormHttpSaveBtn.jsx';

const schema = object({
  email: string().email('必須為有效電郵地址').required('必填'),
  password: string().min(7, '至少7個字').required('必填'),
  confirmPassword: string().required('必填').oneOf(
    [ref('password')],
    '必須與新密碼一致',
  ),
  // lv: string().required('必填'),
  name: object({
    full: object({
      en: string().required('必填'),
      zhhk: string().required('必填'),
    }),
  }),
  open: object({
    category: string().required('必填'),
  }),
});
const defaults = {
  email: '',
  password: '',
  confirmPassword: '',
  name: {
    full: { en: '', zhhk: '' },
  },
  open: {
    category: '',
    school: '',
    schoolClass: '',
    studentId: '',
  },
};

const FormRegister = ({ res, onSubmit }) => (
  <Formik
    validationSchema={schema}
    initialValues={defaults}
    validateOnMount={true}
    onSubmit={(values) => onSubmit(omit(values, 'confirmPassword'))}
  >
    {({ values }) => (
      <Form>
        <FormHttpAlert res={res} />
        <div className="mb-3">
          *為必填資料
        </div>
        <FormGroup
          name="name.full.zhhk"
          label="中文姓名*"
        />
        <FormGroup
          name="name.full.en"
          label="英文姓名*"
        />
        <FormGroup
          name="email"
          label="電郵*"
        />
        <FormGroup
          name="password"
          type="password"
          label="密碼*"
          affirm
        />
        <FormGroup
          name="confirmPassword"
          type="password"
          label="確認密碼*"
          affirm
        />
      {/*
        <FormGroup
          name="lv"
          as="select"
          label="選擇您要參加的組別"
        >
          <option value="" disabled> - </option>
          {Object.keys(env.lvs).map((key) => (
            <option value={key} key={key}>
              {env.lvs[key].zhhk}
            </option>
          ))}
        </FormGroup>
      */}
        <FormGroup
          name="open.category"
          as="select"
          label="身份*"
        >
          <option value="" disabled> - </option>
          <option value="teacher">老師</option>
          <option value="student">學生</option>
          <option value="parent">家長</option>
          <option value="public">公眾</option>
        </FormGroup>

        {['teacher', 'student'].includes(values.open.category) && (
          <FormGroup
            name="open.school"
            label="學校"
          />
        )}

        {values.open.category === 'student' && (
          <>
            <FormGroup
              name="open.schoolClass"
              label="班別"
            />
            <FormGroup
              name="open.email"
              label="學號"
            />
          </>
        )}

        <div className="form-group text-right">
          <FormHttpSaveBtn
            res={res}
            type="submit"
            className="btn-secondary btn-block"
            icon={faClipboardCheck}
          >
            登記
          </FormHttpSaveBtn>
        </div>
      </Form>
    )}
  </Formik>
);

export default FormRegister;
